
const storeProjectId: string | null = localStorage.getItem('projectId');


  
  export const initialValuesSpecReview={
    surveyQuestions: [
      {
        id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        projectId: storeProjectId,
        questionId: 0,
        question: "",
        answer: {
          id: 0,
          value: ""
        }
      }
    ]
  }

 